import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { getToken, setToken } from "@/lib/api";
import { trySilentSso } from "@/lib/silentSso";
import { planGate } from "@/lib/planGate";
import { registerServiceWorker } from "@/lib/pwa";

registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

trySilentSso({ hasToken: () => !!getToken(), setToken: (t) => setToken(t) });

// A free account that opens a paid app's address directly gets an upgrade notice, not the app.
planGate({ product: "stories", getToken: () => getToken() }).then((ok) => {
  if (!ok) return;
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
